import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import CookieManager from "../services/cookie-manager";

export default class UrlParameterHandlerBehaviour extends AbstractDataAttributeBehaviour {

    cookieDurationSeconds = 86400;
    attrInput = 'parameter-value-from-cookie';
    allowedCookies = [ 'DigitalSource', 'FriendCode'];

    constructor()
    {
        super();

        this.cookieManager = new CookieManager;
        this.vars = window.location.search.substring(1).split("&");

        if (this.vars[0] !== '') {
            for (let i = 0; i < this.vars.length; i++) {
                let pair = this.vars[i].split("=");
                let cookieName = pair[0];
                let cookieValue = pair[1];

                if (isInArray(cookieName, this.allowedCookies)) {
                    this.setCookieValue(cookieName, cookieValue);
                }
            }
        }

        function isInArray(value, array) {
            return array.indexOf(value) > -1;
        }
    }

    getContainerSelector()
    {
        return '[data-' + this.attrInput + ']';
    }

    initContainer(container)
    {
        let cookieName = container.getAttribute('data-'+this.attrInput);
        if (this.getCookieValue(cookieName)) {
            container.value = this.getCookieValue(cookieName);
        }
    }

    getCookieValue(cookieName)
    {
        return this.cookieManager.getCookie(cookieName);
    }

    setCookieValue(cookieName, cookieValue)
    {
        var cookieDate = new Date();
        cookieDate.setSeconds(cookieDate.getSeconds() + this.cookieDurationSeconds);
        this.cookieManager.setCookie(cookieName, cookieValue, cookieDate);
    }
}

